import React, { useState, useEffect, useContext } from "react";
import AcademicCareerTable from './academicCareerTable';
import { getAPI, putpost, masterServiceBaseUrl } from 'services/http';
import { GetPagination } from "../../common/commonComponents/pagination/pagination";
import { fetchDetails } from "../../common/utils/methods/commonMethods/utilityMethod";
import { PermissionContext, RolePermissions } from "../../../../../appContext";
import { pages } from "../../common/constant";
import CustomLoader from "../../common/commonComponents/Loader/loader";
import CourseComponentTable from "../courseComponent/courseComponentTable";
import { PermisionDenied } from "../../common/commonComponents";
import { failureToast } from '../../common/utils/methods/toasterFunctions/function';

const AcademicCareer = () => {
  const [classArray, setclassArray] = useState([])
  const [apiloader, setapiloader] = useState(false)
  const [state, setstate] = useState([])
	const [isSaveVisible, setisSaveVisible] = useState(false);
  const [pagination, setpagination] = useState({
    currentPage: 1,
    nextPage: null,
    previousPage: null,
    totalPage: null
  })
  const pageSize = 10

  const permissions = useContext(PermissionContext);

  const userPermissions = RolePermissions(
    permissions,
    pages['academicCareer']['id']
  );

  const fetchClasses = async (url) => {
    setapiloader(true)
    getAPI(url, (data) => {
      setstate(data['data'])
      let n = pagination
      if (data['data'].length > pageSize) {
        n['nextPage'] = n.currentPage + 1
      }
      if (n.currentPage > 1) {
        n.previousPage = n.currentPage - 1
      }
      n['totalPage'] = Math.floor(data['data'].length / pageSize)
      if (data['data'].length % pageSize != 0) {
        n['totalPage'] += 1
      }
      setpagination(n)
      setapiloader(false)
      setclassArray(data['data'].slice(pagination.currentPage * (pageSize) - pageSize, pagination.currentPage * pageSize) || [])
    }, (data) => { failureToast(data['message']) })
  }
  const nextPage = () => {
    setclassArray(state.slice((pagination.currentPage + 1) * (pageSize) - pageSize, (pagination.currentPage + 1) * pageSize))
    let n = pagination
    n['currentPage'] = n['currentPage'] + 1
    n['previousPage'] = n.currentPage
    setpagination(n)
  }
  const firstPage = () => {
    setclassArray(state.slice(1 * (pageSize) - pageSize, 1 * pageSize))
    let n = pagination
    n['currentPage'] = 1
    n['previousPage'] = null
    setpagination(n)
  }
  const lastPage = () => {
    setclassArray(state.slice((pagination.totalPage) * (pageSize) - pageSize, (pagination.totalPage) * pageSize))
    let n = pagination
    n['currentPage'] = n.totalPage
    n['previousPage'] = n.totalPage - 1
    setpagination(n)
  }
  const previousPage = () => {
    if (pagination.currentPage != 1) {
      setclassArray(state.slice((pagination.currentPage - 1) * (pageSize) - pageSize, (pagination.currentPage - 1) * pageSize))
      let n = pagination
      n['currentPage'] = n['currentPage'] - 1
      if (n['currentPage'] == 1) {
        n['previousPage'] = null
      } else {
        n['previousPage'] = n.currentPage
      }
      setpagination(n)
    }
  }
  const [companyCode, setCompanyCode] = useState([])
  useEffect(() => {
    fetchClasses(masterServiceBaseUrl + '/academicCareer/getAllAcademicCareer');
    fetchDetails(masterServiceBaseUrl + `/companyCode/getAllActiveCompanyCode`, setCompanyCode, 'companyCode', 'reactSelect');
  }, [])
  return (
    <>
      {apiloader ? (
        <CustomLoader
          apiLoader={apiloader}
          loaderHeight={'200px'}
          loaderWidth={'100% '}
        />
      ) : (
        <>
          {
            userPermissions ? (
              <>
                <AcademicCareerTable
                  companyCode={companyCode}
                  previousPage={previousPage}
                  fetchClasses={fetchClasses}
                  setclassArray={setclassArray}
                  classArray={classArray}
                  permissionSet={userPermissions}
                  isSaveVisible={isSaveVisible}
                  setisSaveVisible={setisSaveVisible}
                />
                {pagination.totalPage > 1 ?

                  <GetPagination
                    isSaveVisible={isSaveVisible}
                    fetchClasses={fetchClasses}
                    setclassArray={setclassArray}
                    pagination={pagination}
                    setpagination={setpagination}
                    pageSize={pageSize}
                    state={state}
                  />

                  : null}
              </>
            ) : (
              <PermisionDenied />
            )}
        </>
      )}
    </>
  );
}

export default AcademicCareer;